import React from 'react';
import { Result, Button } from 'antd';
import { history } from 'umi';

export default () => {
  return (
    <Result
      status="404"
      title="404"
      subTitle="对不起，你访问的页面不存在！"
      extra={
        <Button
          type="primary"
          onClick={() => {
            history.replace('./result_list');
          }}
        >
          Back Home
        </Button>
      }
    />
  );
};
